import * as fcl from '@onflow/fcl';
import '../flow/config.js';
import { get_all_nfts_from_account } from '../flow/cadence/scripts/getAllNftsFromAccount';
import { get_all_nfts_from_account_metaverse } from '../flow/cadence/scripts/getAllNFTsFromAccMetaverse.js';
import { get_all_nfts_from_account_metaverse_old } from '../flow/cadence/scripts/getAllNFTsFromAccMetaverseOld.js';
import { get_any_nfts_from_account } from '../flow/cadence/scripts/getAnyNftsFromAcc.js';

export type TypeNFTs = 'marketplace' | 'land' | 'oldLand';

const typeNFTs = {
  marketplace: get_all_nfts_from_account,
  land: get_all_nfts_from_account_metaverse,
  oldLand: get_all_nfts_from_account_metaverse_old,
};

class ScriptsService {
  async GetAllNftsFromAccount(from: string, type: TypeNFTs) {
    try {
      const result = await fcl.query({
        cadence: typeNFTs[type],
        args: (arg, t) => [arg(from, t.Address)],
      });

      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  async GetAnyNftsFromAccount(ownerAddress: string) {
    try {
      const result = await fcl.query({
        cadence: get_any_nfts_from_account,
        args: (arg, t) => [arg(ownerAddress, t.Address)],
      });

      console.log(result);
      return result;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}

export const scriptsService = new ScriptsService();
